module.exports = __webpack_public_path__ + "2afc8d45ab4daf9966eea20f6bd8c3be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/list-img.jpg
// module id = 1060
// module chunks = 0